import React from "react";
import { View, Text, StyleSheet } from "react-native";
import LhButton from "../../../components/LhButton";
import { LeadershipWalkRecord } from "../utils/fetchLeadershipWalkData";
import { useTheme } from "../../../theme";

interface LeadershipWalkDetailsProps {
  isVisible: boolean;
  selectedWalk: LeadershipWalkRecord;
  onBackPress: () => void;
  isLoading?: boolean; // Optional loading state prop
}

const LeadershipWalkDetails: React.FC<LeadershipWalkDetailsProps> = ({
  isVisible,
  selectedWalk,
  onBackPress,
  isLoading = false,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDarkMode = resolvedTheme === "dark";
  if (!isVisible) {
    return null;
  }

  return (
    <View
      style={[
        styles.container,
        { backgroundColor: colors.background.page },
      ]}
      testID="leadership-walk-details"
    >
      <View style={styles.header}>
        <LhButton text="Back" variant="secondary" onPress={onBackPress} />
        <Text
          style={[
            styles.title,
            { color: isDarkMode ? colors.text.inverse : colors.text.primary },
          ]}
        >
          Leadership Walk Details
        </Text>
      </View>

      {isLoading ? (
        <View style={styles.loadingContainer}>
          <Text
            style={[
              styles.loadingText,
              { color: isDarkMode ? colors.text.inverse : colors.brand.primary },
            ]}
          >
            Loading leadership walk details...
          </Text>
        </View>
      ) : (
        <View style={styles.content}>
          <Text style={{ color: isDarkMode ? colors.text.inverse : colors.text.primary }}>Zone: {selectedWalk.Zone}</Text>
          <Text style={{ color: isDarkMode ? colors.text.inverse : colors.text.primary }}>Frequency: {selectedWalk.Frequency}</Text>
          <Text style={{ color: isDarkMode ? colors.text.inverse : colors.text.primary }}>
            Created: {new Date(selectedWalk.Created).toLocaleString()}
          </Text>
          <Text style={{ color: isDarkMode ? colors.text.inverse : colors.text.primary }}>Status: {selectedWalk.status}</Text>
          <Text style={{ color: isDarkMode ? colors.text.inverse : colors.text.primary }}>Notes: {selectedWalk.Notes}</Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FFFFFF",
    padding: 16,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 24,
  },
  title: {
    fontSize: 20,
    fontWeight: "600",
    marginLeft: 16,
  },
  content: {
    gap: 16,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  loadingText: {
    fontSize: 16,
    color: "#0066CC",
    marginTop: 10,
  },
});

export default LeadershipWalkDetails;
